import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'commaToSlash',
    standalone: false
})
export class CommaToSlashPipe implements PipeTransform {
  transform(value: number[]): string {
    return value.join(' / ');
    }
}
